<template>
  <div class="animated fadeIn list-mutasi">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Tambah Mutasi</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Ubah</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Hapus</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Ekspor
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Customer</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.CustName"
              @keyup.13.native="lkuKoranCustShow=true"
              @change="tblData.customer_id=''"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Tanggal Mutasi</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">s.d</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Sales(AE) | Kolektor</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_name" placeholder="Sales (AE)" @change="tblData.salesid_id=''"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button"  @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-form-input v-model="tblData.collector_name"  @change="tblData.collector_id=''" placeholder="Kolektor" class="ml-2"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCollectShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Group/Type</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.customer_group" :plain="true" :options="customerGroups"></b-form-select>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()">
              <i class="fa fa-refresh"></i> Apply Filter
            </b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear Filter
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(createdate)="data">
            {{data.item.createdate | ambilNamaHari}}, {{ data.item.createdate | moment("DD-MMM-YYYY hh:mm:ss") }} 
        </template>
        <template v-slot:cell(tanggal)="data">
            {{data.item.tanggal | ambilNamaHari}}, {{ data.item.tanggal | moment("DD-MMM-YYYY") }} 
        </template>

        <template v-slot:cell(berlakuMutasi)="data">
          <span v-if="(data.item.onlyToday)">HANYA {{ data.item.tanggal | moment("ddd, DD-MMM-YY")}}</span>
          <span v-else>SETERUSNYA: {{data.item.berlakuHari}}</span>
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group style="width: 200px;">
              <b-input-group-prepend class="mb-0"><span class="p-2">Limit per page</span></b-input-group-prepend>
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Agen/Langganan"
      :centered="true"
    >
      <lku-customerkoran @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>
    <b-modal
      v-model="lkuKoranSalesShow"
      size="lg"
      :hide-footer="true"
      title="List Sales"
      :centered="true"
    >
      <lku-salesae @click="onSelectKoranSales" crudfilter="koran=1"></lku-salesae>
    </b-modal>
    <b-modal
      v-model="lkuKoranCollectShow"
      size="lg"
      :hide-footer="true"
      title="List Kolektor"
      :centered="true"
    >
      <lku-collector @click="onSelectKoranCollect"></lku-collector>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>
<style lang="scss">
  .list-mutasi {
      table {
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
}
</style>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import koran_mutasi_psn from "../../apis/koran_mutasi_pesanan";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuCollector from "../lookup/lkuCollector";

import customer from "../../apis/customer";
import toastr from "mini-toastr";
import moment from "moment";
toastr.init();

export default {
  components: { Loading, lkuCustomerkoran, lkuSalesae, lkuCollector },
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showFilter: false,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      terpilih: { customer_id: "" },
      customerGroups: [],
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,

        sortBy: null,
        sortDesc: false,
        koran: "1"
      },
      limit:15,
        pagination: false,
      lkuKoranCustShow: false,
      lkuKoranSalesShow: false,
      lkuKoranCollectShow: false
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "createdate",
          label: "Tgl&Jam Mutasi",
          sortable: true
        },
        {
          key: "CustCode",
          thStyle: "width:150px",
          label: "Kode Agen",
          sortable: true
        },
        {
          key: "CustName",
          label: "Nama Agen",
          sortable: true
        },
        {
          key: "DeliveryAddr",
          label: "Alamat pengiriman",
          sortable: true
        },
        {
          key: "PhoneNo",
          label: "Phone",
          thStyle: "width:100px"
        },

        {
          key: "tanggal",
          label: "Tanggal Efektif",
          sortable: true
        },        
        {
          key: "agen_eceran",
          label: "Oplah Mutasi",
          thStyle: "width:60px",
          sortable: true
        },
        {
          key: "berlakuMutasi",
          label: "Masa Berlakunya",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "uraian",
          label: "Alasan Mutasi"
        }
      ];
      return fields;
    }
  },
  created: async function() {
    const groups = await customer.group();
    this.customerGroups = groups.reduce(
      (newArr, item) => {
        newArr.push(item);
        return newArr;
      },
      [{ value: "", text: "---ALL---" }]
    );
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },   
  filters: {
    ambilNamaHari(tanggal) {
      const namesDay = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ];
      const day_ = namesDay[moment(tanggal).day()];
      return day_;
    }
  },  

  methods: {
    onSelectKoranCust: function(_selected) {
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.CustName = _selected.CustName;
      this.lkuKoranCustShow = false;
    },
    onSelectKoranSales: function(_selected) {
      this.tblData.salesae_id = _selected.salesae_id;
      this.tblData.salesae_name = _selected.salesae_name;
      this.lkuKoranSalesShow = false;
    },
    onSelectKoranCollect: function(_selected) {
      this.tblData.collector_name = _selected.collector_name;
      this.tblData.collector_id = _selected.collector_id;
      this.lkuKoranCollectShow = false;
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.mutasiPesKoranList) {
            this.tblData[key] = filter.mutasiPesKoranList[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.mutasiPesKoranList.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.mutasiPesKoranList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await koran_mutasi_psn.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await koran_mutasi_psn.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }

    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.CustName = '';
      this.tblData.customer_id = '';
      this.tblData.customer_group = '';
      this.tblData.kota_id = '';
      this.tblData.kota_name = '';
      this.tblData.jurusan_id = '';
      this.tblData.jurusan_name = '';
      this.tblData.collector_id = '';
      this.tblData.collector_name = '';
      this.tblData.tgl1 = '';
      this.tblData.tgl2 = '';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','tgl1', 'tgl2', 'customer_id', 'CustName',  'customer_group', 'collector_id', 'collector_name', 'salesae_id', 'salesae_name'];
      let filtered = false;
      const mutasiPesKoranList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              mutasiPesKoranList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          mutasiPesKoranList.page=this.tblData.page;
          mutasiPesKoranList.limit=this.tblData.limit;
          mutasiPesKoranList.sortBy=this.tblData.sortBy;
          mutasiPesKoranList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.mutasiPesKoranList=mutasiPesKoranList;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.terpilih = record;
      this.edit();
    },
    // rowPrint(record) {
    //   this.rowClicked(record);
    //     this.print();        
    // },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },      
    add(){
      this.saveFilter();    
      router.push({ name: "koran.mutasipesananfrm" });
    },
    edit: function() {
      if (this.terpilih.mutasiKey) {
        this.saveFilter();    
        router.push({
          name: "koran.mutasipesananfrm",
          params: {
            customer_id: this.terpilih.customer_id,
            mutasiKey: this.terpilih.mutasiKey
          }
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.terpilih.mutasiKey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Deleted!");
      }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await koran_mutasi_psn.remove(this.terpilih);
      this.refresh();
        // const index= this.items.findIndex(r => (r.mutasiKey==this.terpilih.mutasiKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    rowClicked(record, index) {
      // if (this.terpilih.customer_id == record.customer_id) {
      //   this.edit();
      // } else {
        if (this.terpilih && this.terpilih._rowVariant) {
          delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      // }
    },

    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await koran_mutasi_psn.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("/receivable/home");
    }
  }
};
</script>